const learningStandard = {
  '03': 0.95,
  '04': 0.95,
  '05': 0.9,
  '06': 0.9,
  '07': 0.9,
  '08': 0.9,
  '09': 0.9,
  10: 0.8,
  11: 0.8,
  12: 0.8,
  13: 0.7,
  14: 0.7,
  15: 0.7,
  16: 0.7,
  17: 0.7,
  18: 0.7,
  19: 0.7,
  20: 0.7,
  21: 0.7,
};

export default learningStandard;
